'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _ramda = require('ramda');
var _ManualForm = require('../ManualForm/ManualForm');var _ManualForm2 = _interopRequireDefault(_ManualForm);
var _VirtualNumbersForm = require('../VirtualNumbersForm/VirtualNumbersForm');var _VirtualNumbersForm2 = _interopRequireDefault(_VirtualNumbersForm);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

UpdatePropertyActivityContactsForm = function (_React$Component) {_inherits(UpdatePropertyActivityContactsForm, _React$Component);function UpdatePropertyActivityContactsForm() {_classCallCheck(this, UpdatePropertyActivityContactsForm);return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));}UpdatePropertyActivityContactsForm.prototype.
  render = function render() {var _props =
    this.props,virtualNumbers = _props.virtualNumbers,props = _objectWithoutProperties(_props, ['virtualNumbers']);
    return virtualNumbers.length ?
    _react2.default.createElement(_VirtualNumbersForm2.default, props) :

    _react2.default.createElement(_ManualForm2.default, props);

  };return UpdatePropertyActivityContactsForm;}(_react2.default.Component);


UpdatePropertyActivityContactsForm.propTypes = {
  translate: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool,
  virtualNumbers: _propTypes2.default.array,
  onFormSubmit: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool };


var mapStateToProps = function mapStateToProps(_ref) {var userAuthentication = _ref.userAuthentication;
  var virtualNumbers = (0, _get2.default)(userAuthentication, 'data.virtual_numbers') || [];
  return {
    virtualNumbers: virtualNumbers };

};exports.default =


(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps))(
UpdatePropertyActivityContactsForm);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UpdatePropertyActivityModal/Form/Form.js
// module id = 2919
// module chunks = 0